import textFieldStyles from '@/blocks/components/Controls/TextField/styles.module.scss';
import { useIsRtl } from '@/hooks/useIsRtl';
import { default as TF } from '@mui/material/TextField';
import classNames from 'classnames';
import { useState } from 'react';

export function TextField(props: React.ComponentProps<typeof TF>) {
  const { isRtl } = useIsRtl();
  const [localShrinkLabel, setLocalShrinkLabel] = useState(false);
  return (
    <TF
      {...props}
      multiline={props.multiline}
      className={classNames(
        textFieldStyles.textField,
        props.multiline && textFieldStyles.textarea,
        props?.InputProps?.startAdornment && textFieldStyles.MuiTextFieldAdornedStart,
        isRtl && textFieldStyles.MuiTextFieldRtl,
        props?.inputProps?.value && textFieldStyles.MuiTextFieldFilled,
        props.className,
      )}
      onBlur={(...args) => {
        setLocalShrinkLabel(false);
        if (typeof props.onBlur === 'function') {
          props.onBlur(...args);
        }
      }}
      onFocus={(...args) => {
        setLocalShrinkLabel(true);
        if (typeof props.onFocus === 'function') {
          props.onFocus(...args);
        }
      }}
      InputLabelProps={{
        ...props.InputLabelProps,
        shrink: Boolean(
          props.InputLabelProps?.shrink || props?.inputProps?.value || props.value || localShrinkLabel,
        ),
      }}
    />
  );
}
